import { useEffect, useCallback, useState } from 'react';
// import { withStyles } from '@material-ui/core/styles';
// import { makeStyles } from '@material-ui/core/styles';
// import { Fab } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

import ReactApiService from '../../services/reactApiService'

/*
const DeleteButton = withStyles((theme) => ({
	root: {
		backgroundColor: '#00c8f4',
    '&:hover': {
      backgroundColor: '#90caf9',
    },	
	}
}))(Fab);
// */

// 
export default function ButtonDelete(props) {
	
	// const classes = useStyles();
  const [values, setValues] = useState({
    mask: false,
		rowClassWrapper: false
  });
	
	// keep function reference.
  const deleteMask = useCallback(() => {
		const dataService = new ReactApiService();
		dataService.post({endpoint:'updateMasks',body:{masks:'masks',action:'updateMasks'}})
			.then( 
				(response) => {
					// setContent((prev) => response);
					// setValues({ ...values, ['mask']: false, ['rowClassWrapper']: false });
				},
				(error) => {}
			).then(() => {
					let elems = document.getElementsByClassName(values.rowClassWrapper)
					// console.log('elems::', elems.length);
					if ( elems.length === 1 ) {
						elems[0].style.display = 'none';
					}
				}
			)
  }, [values]) 	
	
	useEffect(() => {
		// console.log(' useEffect values::', values);
		if ( false !== values.mask ) {
			deleteMask();
			// @see switcher.js works without `values` param
		}
	  return () => {
			// console.log('return from useEffect content changed:: ');
	  }		
	},[values,deleteMask]);

	const handleClick = (e) => {
		let dataset = e.target.parentNode.dataset;
		if ( 'undefined' !== typeof dataset.mask ) {
			setValues({ 
				...values, 
				'mask': dataset.mask, 
				'rowClassWrapper': props.rowClassWrapper+'-'+dataset.id  
			});
		}
	}

  return (
			<span className={'button-action button-delete'} data-id={props.params.id} data-mask={props.params.row.mask} onClickCapture={handleClick}  >		
				<DeleteIcon 
					className={'delete-icon'} 
					size='small'
					color='primary' 
					aria-label='delete'
					data-id={props.params.id} 
					data-mask={props.params.row.mask} />
			</span>						
  );
}
